<div class="container-fluid">
<div class = "uploadcontainer">
<mat-card>
    <mat-card-header>
        <mat-card-title>Upload Files</mat-card-title>
        <mat-card-subtitle>Please select Files to Upload</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div>
            <input type="file" (change)="handleFileInput($event.target.files)">
        </div>
    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
</mat-card>
</div>
<div class="tablecontainer">
    <h2>Upload Queue</h2>
<mat-accordion displayMode="flat" multi class="mat-table">
    <section matSort class="mat-elevation-z2 mat-header-row">
        <span class="mat-header-cell" >Image</span>
        <span class="mat-header-cell" >Name</span>
        <span class="mat-header-cell" >Type</span>
        <span class="mat-header-cell" >Size</span>
        <span class="mat-header-cell" >Action</span>
      </section>

      <mat-expansion-panel>
        <mat-expansion-panel-header class="mat-row">
            <span class="mat-cell"></span>
      <span class="mat-cell">{{fileToUpload.name}}</span>
      <span class="mat-cell">{{fileToUpload.type}}</span>
      <span class="mat-cell">{{fileToUpload.size}}</span>
      <span class="mat-cell toolbar-buttons"></span>
        </mat-expansion-panel-header>
        <div *ngIf="fileToUpload">
        <button mat-raised-button (click)="getCategory();">Select Category</button>
        <!-- <div class="property-container">
        <mat-form-field>
            <mat-label>documentTitle</mat-label>
            <input matInput placeholder="Ex. Nougat" [(ngModel)]="documentTitle">
          </mat-form-field>
        </div> -->
        <div class="form-group">
            <label>Document Title</label>
            <input class="form-control" name="documentTitle" [(ngModel)]="documentTitle">
        </div>
        <div *ngFor="let prop of category.meta_data_definition.properties; index as i; trackBy:trackByIndex;">
            <div class="form-group">
                <label>{{prop.name}}</label>
                <input class="form-control" name="{{'name'+i}}" [(ngModel)]="category.meta_data_definition.properties[i].value">
            </div>
        </div>
    </div>
      </mat-expansion-panel>
</mat-accordion>
<button type="button" class="btn btn-primary" type="submit" (click)="uploadDocument()">Upload Document</button>
</div>
</div>
